import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface callGetSrtTokenProps {
  from?: string | null;
  to?: string | null;
  billingAccountId?: string;
}

export const useAISrtTokens = ({
  from,
  to,
  billingAccountId,
}: callGetSrtTokenProps) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  if (billingAccountId) queryParams.append('billingAccountId', billingAccountId);

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['srt-ai', from, to, billingAccountId],
    queryFn: async () => {
      const response = await fetchAPI<{message: string, data: AISrtCount[]}>({
        method: `GET`,
        route: `srt/ai`,
        queryString
      });
      return response;
    },
    enabled: !!from && !!to,
    // Analytics charts aggregate historical data — minutes-old freshness is
    // plenty, and the underlying query is one of the heavier ones.
    staleTime: 10 * 60 * 1000
  });
};

export default useAISrtTokens;
